export const airportsOrder = [
	'ChIJ41zpQhwzGUcR0ehDaKL1xSI', // Chopina
	'ChIJZ4xL7SdZFkcR1Mwtra0t3j0', // Kraków
	'ChIJ8eQhiTSe_UYR-JUf3ZO59IM', // Gdańsk
	'ChIJv11892_AD0cRf27AnQ6i4CQ', // Wrocław
	'ChIJneKyVa5FBEcRfWWTxgwX7UM', // Poznań
	'ChIJwwUsj0GlHkcRYXefnNYCGHs', // Modlin
	'ChIJLb2T-1sqF0cR3zFjIxMOr7w', // Katowice
	'ChIJH2sQUhcTA0cRFGBrNh3I2YQ', // Bydgoszcz
	'ChIJ9V9pp6I1GkcRiWYwtqaBvMU', // Łódź
	'ChIJj_iqanvkPEcRbNlbPWXfm4s', // Rzeszów
	'ChIJ-9KhEmOZAEcR2vn-t5vUEWI', // Szczecin
	'ChIJR74qznZUIkcRuEwWIkG2csk', // Lublin
	'ChIJ3dQ4Z5FwBkcR59w6pBCuINE', // Zielona Góra
	'ChIJU5p6EmrwHUcRXYlvQG0p7hA', // Olsztyn
	'ChIJNeEnGklfGEcRLQCaczam3ZY', // Warszawa-Radom
]

export const branchesOrder = [
	'ChIJm7fQXhsJqkcR7uQEoC4USr8', // Jerozolimskie
	'ChIJwaQscSAzGUcRuLGV50QDczE', // Cybernetyki
	'ChIJUdk3CxpbFkcRkuq4Azj30FE', // Kraków
	'ChIJpSaLZM1z_UYRQPhiB-OeGas', // Gdańsk
	'ChIJ-4nbblTDD0cROUaetd4mRF8', // Wrocław
	'ChIJd5jGjfpbBEcRk314jZSV1_o', // Poznań
	'ChIJZdR7kUfOFkcR1I8wvOUCUAg', // Katowice
	'ChIJmT4h2ssTA0cRKKIIztfZrec', // Bydgoszcz
	'ChIJ9xedsC7LG0cRlZuZZ6y4BfE', // Łódź
	'ChIJlU8GFR37PEcRnIbNkdZ1Cs8', // Rzeszów
	'ChIJs9KCygQJqkcRM5Hk3qjA8hg', // Szczecin
	'ChIJ01wqxOgnGEcR_0mfti5yuv4', // Kielce
	'ChIJq95X42hXIkcRpccA4G5umh0', // Lublin
	'ChIJCegw5MMTBkcRaJB79QkvjBw', // Zielona Góra
	'ChIJ7VAGAtp44kYRy3_FoJYkqqU', // Olsztyn
	'ChIJaQR7qR78H0cR6qcYYujZtIQ', // Białystok
	'ChIJu0E1JNu1EEcRsIe6LwD1CsY', // Częstochowa
	'ChIJ1UpeupI0A0cRUXXXyBne9lQ', // Toruń
]
